export default __webpack_public_path__ + "static/28-702b68e8f63e5f25f30a82c0ffd54cd1.jpg";